import React, { useState, useEffect } from "react";

import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import DefaultImage from "../../../assets/images/icons/sampleimage.jpg";
import { useSelector } from "react-redux";
import logoImg from "../../../assets/images/logo-img.png";
import moment from "moment";
import AdminJewelryReportService from "../../../services/admin-jewelryReport-service";
import ReportJewelryReportService from "../../../services/reports-Jewelry-service";
import DoughnutChart from "../../admin/JewelryReport/Doughnut";
import { useTranslation } from "react-i18next";
import NoReportDataIcon from "../../../assets/images/no-report-img.png";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { Button, DatePicker, Modal, Select, Spin, Table, Tooltip } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/*Initial State for Binding Starts*/
const initialEventState = {
  dealerID: "",
  forDealer: "",
  fromDate: moment().subtract(30, "days"),
  toDate: moment(),
  retailerIds: [],
  vendorIds: [],
  price: "",
  price1: "",
  price2: "",
};
/*Initial State for Binding Ends*/
const { RangePicker } = DatePicker;
const { Option } = Select;

const GlobalJewelryChartReports = () => {
  const { t } = useTranslation();
  const [selectedData, setSelectedData] = useState(initialEventState);
  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);
  const [categoryColumnData, setCategoryColumnData] = useState([]);
  const [countCategoryColumnData, setCountCategoryColumnData] = useState([]);
  const [priceRange, setpriceRange] = useState([]);
  const [priceTotal, setPriceTotal] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [selectedImage, setSelectedImage] = useState();
  const [visible, setVisible] = useState(false);
  const loginDetials = useSelector((state) => state.loginReducer);
  const [tableChartData, setTableChartData] = useState([]);
  const [showChartPrice, setShowChartPrice] = useState(false);
  const [showChartCategory, setShowChartCategory] = useState(false);
  const [categoryChartLoading, setCategoryChartLoading] = useState(true);
  const [priceChartLoading, setPriceChartLoading] = useState(true);
  const [defaultVisible, setDefaultVisible] = useState(false);
  const [key, setKey] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [categoryTotalValuePercentage, setCategoryTotalValuePercentage] =
    useState(0);
  const [priceTotalValuePercentage, setPriceTotalValuePercentage] = useState(0);
  const [dealerMemberTypeName, setDealerMemberTypeName] = useState("");
  const [chartType, setChartType] = useState("");
  const [chartSection, setChartSection] = useState("");
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");

  // New state for chart data and colors
  const [categoryChartData, setCategoryChartData] = useState([]);
  const [categoryColorData, setCategoryColorData] = useState([]);
  const [priceChartData, setPriceChartData] = useState([]);
  const [priceColorData, setPriceColorData] = useState([]);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setSelectedData((prevState) => ({
            ...prevState,
            dealerID: loginDetials.loginDetials.responseData.dealerId,
          }));
          setDealerMemberTypeName(
            loginDetials.loginDetials.responseData.dealerMemberTypeName
          );
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
    handleGetForDealer(loginDetials.loginDetials.responseData.dealerId);
    handleGetVendorDropdownData();
    handleGetRetailerDropdownData();
  }, []);

  const handleGetForDealer = (id) => {
    try {
      const initialEventState = {
        dealerID: id,
      };
      setShowLoader(true);
      AdminJewelryReportService.GetForDealer(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setSelectedData((prevState) => ({
              ...prevState,
              forDealer: responseData.forDealer,
            }));
            handleGetClicksBasedOnVendor(id, responseData.forDealer);
            handleGetClicksBasedOnPrice(id, responseData.forDealer);
            handleGetTopRetailerCoulmnData(id, responseData.forDealer);
            handleGetTotalCount(id, responseData.forDealer);
            handleGetClicksBasedOnCategory(id, responseData.forDealer);
            handleGetTableChartData(id, responseData.forDealer);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetClicksBasedOnVendor = (DealerId, forDealerId) => {
    try {
      const initialEventState = {
        ...selectedData,
        dealerID: DealerId,
        forDealer: forDealerId,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
      };
      setShowLoader(true);
      AdminJewelryReportService.GetClicksBasedOnVendor(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            let dealerCompany = [];
            let total = [];
            for (let i of responseData) {
              dealerCompany.push(i.dealerCompany);
              total.push(i.total);
            }
            setShowLoader(false);
          } else {
            setShowLoader(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const handleGetClicksBasedOnPrice = (DealerId, forDealerId) => {
    try {
      const initialEventState = {
        ...selectedData,
        dealerID: DealerId,
        forDealer: forDealerId,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
      };
      setShowLoader(true);
      setPriceChartLoading(true);
      AdminJewelryReportService.GetClicksBasedOnPrice(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            let showResp = responseData.every((element) => {
              return element.total == "0";
            });
            setShowChartPrice(showResp);
            let range = [];
            let total = [];
            for (let i of responseData) {
              range.push(i.range);
              total.push(i.total);
            }

            let totalValuePercentage = total.reduce(
              (a, b) => (a = Number(a) + Number(b)),
              0
            );
            setPriceTotal(total);
            setpriceRange(range);
            setPriceTotalValuePercentage(totalValuePercentage);
            setShowLoader(false);
            setPriceChartLoading(false);
            setKey(!key);
          } else {
            setShowLoader(false);
            setPriceChartLoading(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
      setShowLoader(false);
      setPriceChartLoading(false);
    }
  };

  const handleGetTopRetailerCoulmnData = (DealerId, forDealerId) => {
    try {
      const initialEventState = {
        ...selectedData,
        dealerID: DealerId,
        forDealer: forDealerId,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
      };
      setShowLoader(true);
      AdminJewelryReportService.GetClicksBasedOnRetailer(
        initialEventState
      ).then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          let dealerName = [];
          let total = [];
          let showResp = responseData.every((element) => {
            return element.total == "0";
          });
          for (let i of responseData) {
            dealerName.push(i.dealerCompany);
            total.push(i.total);
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
        }
      });
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const handleGetClicksBasedOnCategory = (DealerId, forDealerId) => {
    try {
      const initialEventState = {
        ...selectedData,
        dealerID: DealerId,
        forDealer: forDealerId,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
      };
      setShowLoader(true);
      setCategoryChartLoading(true);
      AdminJewelryReportService.GetClicksBasedOnCategory(
        initialEventState
      ).then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          let category = [];
          let count = [];
          let showResp = responseData.every((element) => {
            return element.count == "0";
          });
          setShowChartCategory(showResp);
          for (let i of responseData) {
            category.push(i.category);
            count.push(i.count);
          }
          let totalValuePercentage = count.reduce(
            (a, b) => (a = Number(a) + Number(b)),
            0
          );
          setCountCategoryColumnData(count);
          setCategoryColumnData(category);
          setCategoryTotalValuePercentage(totalValuePercentage);
          setShowLoader(false);
          setCategoryChartLoading(false);
          setKey(!key);
        } else {
          setShowLoader(false);
          setCategoryChartLoading(false);
        }
      });
    } catch (error) {
      console.log(error);
      setShowLoader(false);
      setCategoryChartLoading(false);
    }
  };

  const handleGetTotalCount = (DealerId, forDealerId) => {
    try {
      const initialEventState = {
        ...selectedData,
        dealerID: DealerId,
        forDealer: forDealerId,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
      };
      setShowLoader(true);
      AdminJewelryReportService.GetClicksCount(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            // setCountColumnData(responseData[0].totalCount);
          } else {
            setShowLoader(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const handleExportToCSV = (sortColumn, sorttype) => {
    try {
      const initialEventState = {
        ...selectedData,
        dealerID: selectedData.dealerID,
        forDealer: selectedData.forDealer,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
        category:
          selectedData.section == "category" && selectedData.type
            ? selectedData.type
            : "",
        metalType: "",
        metalColorType: "",
        price: selectedData.price,
        price1: selectedData.price1.trim().toString(),
        price2: selectedData.price2.trim().toString(),
        vendor: "",
        retailer: "",
        reporttype: "Global",
        pageIndex: selectedData.pageNo ? selectedData.pageNo : 1,
        pageSize: selectedData.pageSiz ? selectedData.pageSiz : 15,
        sortColumnName:
          sortColumnName === "UserIPAddress"
            ? "UserIPAddress"
            : sortColumnName === "vendorName"
            ? "vendorName"
            : sortColumnName === "retailerName"
            ? "retailerName"
            : sortColumnName === "collectionNew"
            ? "collectionNew"
            : sortColumnName === "category"
            ? "Category"
            : sortColumnName === "date"
            ? "Date"
            : sortColumnName === "StyleNumber"
            ? "StyleNumber"
            : sortColumnName === "metalType"
            ? "MetalType"
            : sortColumnName === "metalColor"
            ? "MetalColor"
            : sortColumnName === "price"
            ? "Price"
            : "date",
        sortOrder: selectedData.sortOrder
          ? selectedData.sortOrder
          : selectedData.sorttype,
      };

      setDownloadCSVDataloading(true);
      ReportJewelryReportService.ExportDataToCSV(initialEventState)
        .then((response) => {
          setShowTableLoader(false);
          setDownloadCSVDataloading(false);
          var fileName =
            "Global_Jewelry_Report_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
    }
  };

  const handleGetTableChartData = (
    DealerId,
    forDealerId,
    type,
    section,
    pageNumber,
    pageSiz,
    sortColumnName,
    sortOrder
  ) => {
    try {
      const initialEventState = {
        ...selectedData,
        dealerID: DealerId,
        forDealer: forDealerId,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
        category: section == "category" && type ? type : "",
        metalType: "",
        metalColorType: "",
        price: selectedData.price,
        price1: selectedData.price1.trim().toString(),
        price2: selectedData.price2.trim().toString(),
        vendor: "",
        retailer: "",
        reporttype: "Global",
        pageIndex: pageNumber ? pageNumber : 1,
        pageSize: pageSiz ? pageSiz : 15,
        sortColumnName:
          sortColumnName === "UserIPAddress"
            ? "UserIPAddress"
            : sortColumnName === "vendorName"
            ? "vendorName"
            : sortColumnName === "retailerName"
            ? "retailerName"
            : sortColumnName === "collectionNew"
            ? "collectionNew"
            : sortColumnName === "category"
            ? "Category"
            : sortColumnName === "date"
            ? "Date"
            : sortColumnName === "StyleNumber"
            ? "StyleNumber"
            : sortColumnName === "metalType"
            ? "MetalType"
            : sortColumnName === "metalColor"
            ? "MetalColor"
            : sortColumnName === "price"
            ? "Price"
            : "date",
        sortOrder: sortOrder ? sortOrder.toString() : sortType.toString(),
      };
      setShowTableLoader(true);
      AdminJewelryReportService.GetTableChartData(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setTableChartData(responseData);
            setTotalCount(responseData?.[0]?.totalRecords || 0);
            setShowTableLoader(false);
          } else {
            setTotalCount(0);
            setTableChartData([]);
            setShowTableLoader(false);
          }
        }
      );
    } catch (error) {
      setTotalCount(0);
      console.log(error);
      setShowTableLoader(false);
      setSelectedData((prevState) => ({
        ...prevState,
        price: "",
        price1: "",
        price2: "",
      }));
    }
  };

  const handleGetVendorDropdownData = () => {
    const dealerId = loginDetials.loginDetials.responseData.dealerId;
    let inputData = {
      dealerId: dealerId,
      reporttype: "global",
    };
    try {
      AdminJewelryReportService.GetVendorDropdownList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setVendorList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetRetailerDropdownData = () => {
    let inputData = {
      dealerId: 0,
      reporttype: "global",
    };
    try {
      AdminJewelryReportService.GetRetailerDropdownList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setRetailerList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const changeRetailerListHandler = (data) => {
    try {
      data = data.toString();
      let inputData = {
        vendorIds: data,
      };
      AdminJewelryReportService.ChangeRetailerList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setRetailerList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const changeVendorListHandler = (data) => {
    try {
      data = data.toString();
      let inputData = {
        retailerIds: data,
      };
      AdminJewelryReportService.ChangeVendorList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setVendorList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setSelectedData((prevState) => ({
        ...prevState,
        fromDate: moment.utc(dates[0]).toISOString(),
        toDate: moment.utc(dates[1]).toISOString(),
      }));
    }
  };
  /*DatePicker Binding Ends*/

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select" && name === "vendors") {
      let vId = "";
      if (e.includes(0)) {
        vId = [0];
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: vId,
        }));
      } else {
        vId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: e,
        }));
      }

      if (e.length === 0 || e.includes(0)) {
        // When vendor cleared, check if retailer is still selected
        if (selectedData.retailerIds && selectedData.retailerIds.length > 0 && !selectedData.retailerIds.includes(0)) {
          // Retailer is selected, filter vendors by retailer
          changeVendorListHandler(selectedData.retailerIds);
        } else {
          // No retailer selected, reset both
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        }
      } else {
        changeRetailerListHandler(vId);
      }
    } else if (isSelect === "select" && name === "retailers") {
      let rId = "";
      if (e.includes(0)) {
        rId = [0];
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: rId,
        }));
      } else {
        rId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: e,
        }));
      }

      if (e.length === 0 || e.includes(0)) {
        // When retailer cleared, check if vendor is still selected
        if (selectedData.vendorIds && selectedData.vendorIds.length > 0 && !selectedData.vendorIds.includes(0)) {
          // Vendor is selected, filter retailers by vendor
          changeRetailerListHandler(selectedData.vendorIds);
        } else {
          // No vendor selected, reset both
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        }
      } else {
        changeVendorListHandler(rId);
      }
    }
  };

  const applyFilterHandler = () => {
    setPriceTotal([]);
    setpriceRange([]);
    setCountCategoryColumnData([]);
    setCategoryColumnData([]);
    setCategoryChartLoading(true);
    setPriceChartLoading(true);
    var obj = selectedData;
    obj["price"] = "";
    obj["price1"] = "";
    obj["price2"] = "";
    handleGetClicksBasedOnVendor(selectedData.dealerID, selectedData.forDealer);
    handleGetClicksBasedOnPrice(selectedData.dealerID, selectedData.forDealer);
    handleGetTopRetailerCoulmnData(
      selectedData.dealerID,
      selectedData.forDealer
    );
    handleGetTotalCount(selectedData.dealerID, selectedData.forDealer);
    handleGetClicksBasedOnCategory(
      selectedData.dealerID,
      selectedData.forDealer
    );
    handleGetTableChartData(
      selectedData.dealerID,
      selectedData.forDealer,
      "empty",
      "empty",
      pageNo,
      pageSize
    );
  };

  const imageClickHandler = (img) => {
    setVisible(true);
    setSelectedImage(img);
  };

  const [sortColumnName, setSortColumnName] = useState("GT.MODIFIED");
  const [sortType, setSortType] = useState("desc");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order === "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order === "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "date";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetTableChartData(
      selectedData.dealerID,
      selectedData.forDealer,
      chartType,
      chartSection,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  const columns = [
    {
      title: <Tooltip title={t("Product Image")}>{t("Product Image")}</Tooltip>,
      ellipsis: true,
      dataIndex: "imagePathNew",
      render: (item, data) => (
        <>
          {data.imagePathNew ? (
            <span onClick={() => imageClickHandler(data.imagePathNew)}>
              <img
                src={data.imagePathNew}
                alt="img"
                className="product__img"
                style={{ cursor: "pointer" }}
              />
            </span>
          ) : (
            <span onClick={() => setDefaultVisible(true)}>
              <img
                src={DefaultImage}
                alt="img"
                className="product__img"
                style={{ cursor: "pointer" }}
              />
            </span>
          )}
        </>
      ),
    },
    {
      title: (
        <Tooltip title={t("User IP Address")}>{t("User IP Address")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "userIPAddress",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Vendor")}>{t("Vendor")}</Tooltip>,
      ellipsis: true,
      dataIndex: "vendorName",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Retailer")}>{t("Retailer")}</Tooltip>,
      ellipsis: true,
      dataIndex: "retailerName",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Collection")}>{t("Collection")}</Tooltip>,
      ellipsis: true,
      dataIndex: "collectionNew",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Category")}>{t("Category")}</Tooltip>,
      ellipsis: true,
      dataIndex: "category",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
      ellipsis: true,
      dataIndex: "date",
      defaultSortOrder: "descend",
      sorter: (a, b) => {},
      render: (row, item) => {
        if (Object.keys(item.date).length !== 0) {
          return (
            <React.Fragment>
              <span>{moment(item.date).format("MM-DD-YYYY, hh:mm:ss A")}</span>
            </React.Fragment>
          );
        }
      },
    },
    {
      title: <Tooltip title={t("Style Number")}>{t("Style Number")}</Tooltip>,
      ellipsis: true,
      dataIndex: "styleNumber",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Metal Type")}>{t("Metal Type")}</Tooltip>,
      ellipsis: true,
      dataIndex: "metalType",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Metal Color")}>{t("Metal Color")}</Tooltip>,
      ellipsis: true,
      dataIndex: "metalColor",
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Price")}>{t("Price")}</Tooltip>,
      ellipsis: true,
      dataIndex: "price",
      sorter: (a, b) => {},
      render: (price) => (
        <Tooltip title={price}>
          <span>{price}</span>
        </Tooltip>
      ),
    },
  ];

  const tableSortHandler = (type, section) => {
    var obj = selectedData;
    if (section === "price") {
      const price = type === "Call For Price" ? type : "";
      const price1 =
        type === "None"
          ? "-"
          : type.includes("Call")
          ? ""
          : type.includes("Under")
          ? "0"
          : type.split("-")[0].split("$")[1];
      const price2 =
        type === "None"
          ? "-"
          : type.includes("Call")
          ? ""
          : type.includes("Under")
          ? type.split("$")[1]
          : type.split("-").length > 1
          ? type.split("-")[1].split("$")[1]
          : type;

      obj["price"] = price;
      obj["price1"] = price1;
      obj["price2"] = price2;
    } else {
      obj["price"] = "";
      obj["price1"] = "";
      obj["price2"] = "";
    }
    setChartType(type);
    setChartSection(section);
    setPageNo(1);
    setPageSize(15);
    handleGetTableChartData(obj.dealerID, obj.forDealer, type, section);
  };

  // Category chart options
  const categoryOptions = {
    is3D: true,
    pieHole: 0.5,
    pieSliceText: "percentage",
    tooltip: { trigger: "focus", text: "text" },
    chartArea: { left: "10%", top: "5%", width: "80%", height: "90%" },
    colors: categoryColorData,
    legend: { position: "none" },
  };

  // Price chart options
  const priceOptions = {
    is3D: true,
    pieHole: 0.5,
    pieSliceText: "percentage",
    tooltip: { trigger: "focus", text: "text" },
    chartArea: { left: "10%", top: "5%", width: "80%", height: "90%" },
    colors: priceColorData,
    legend: { position: "none" },
  };


  const handleDownloadCategoryPieChart = async () => {
    try {
      // ------------ 1. High-Res Chart Setup -----------------
      const pdfChartOptions = {
        ...categoryOptions,
        width: 1800,
        height: 950,
        chartArea: { left: 50, top: 140, width: "100%", height: "100%" },
        legend: { position: "none" },
        pieHole: 0.4,
        pieSliceText: "percentage",
        tooltip: { text: "percentage" },
        pieSliceTextStyle: { fontSize: 18, color: "#000" },
        colors: categoryColorData, // Use same colors as legend
      };

      // ------------ 2. Hidden DOM Container -----------------
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-piechart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // ------------ 3. Custom Legends -----------------
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "flex-start";
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      categoryChartData.slice(1).forEach((row, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "16px";
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = categoryColorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const labelText = row[0].replace(/\s*\([^)]*\)\s*/g, "");
        const valueText = ` (${row[1]})`;

        const textNode = document.createTextNode(labelText + valueText);
        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // ------------ 4. Draw Chart -----------------
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "900px";
      hiddenContainer.appendChild(chartDiv);

      const tempChart = new window.google.visualization.PieChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(categoryChartData);

      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // ------------ 5. Convert to Canvas -----------------
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");
      document.body.removeChild(hiddenContainer);

      // ------------ 6. Setup PDF -----------------
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;

      // ------------ 7. Header -----------------
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("JEWELRY CATEGORY REPORT", pageWidth - margin, 11, {
        align: "right",
      });

      // ------------ 8. Dynamic Info Block -----------------

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const normalizeIds = (arr) => arr.map((id) => Number(id));
      const vendorIds = normalizeIds(selectedData.vendorIds);
      const retailerIds = normalizeIds(selectedData.retailerIds);

      const selectedVendorNames =
        vendorIds.length === 0
          ? "All Vendors"
          : vendorList
            .filter((v) => vendorIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const selectedRetailerNames =
        retailerIds.length === 0
          ? "All Retailers"
          : retailerList
            .filter((v) => retailerIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(selectedData.fromDate).format(
        "MMM DD, YYYY"
      )} - ${moment(selectedData.toDate).format("MMM DD, YYYY")}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        ...(dealerMemberTypeName === "Admin"
          ? [
            `Vendors: ${selectedVendorNames}`,
            `Retailers: ${selectedRetailerNames}`
          ]
          : dealerMemberTypeName === "Vendor"
            ? [`Retailers: ${selectedRetailerNames}`]
            : [`Vendors: ${selectedVendorNames}`]
        )
        `Total Clicks: ${totalCount}`
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // split text dynamically
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // ------------ 9. Insert Chart Below Dynamic Text -----------------

      const imgRatio = canvas.width / canvas.height;
      const availableHeight = pageHeight - currentY - footerHeight - 5;

      let imgWidthMM = pageWidth - margin * 2;
      let imgHeightMM = imgWidthMM / imgRatio;

      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        currentY,
        imgWidthMM,
        imgHeightMM,
        undefined,
        "FAST"
      );

      // ------------ 10. Footer -----------------

      pdf.setFillColor(31, 38, 62);
      pdf.rect(
        0,
        pageHeight - footerHeight,
        pageWidth,
        footerHeight,
        "F"
      );

      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);

      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;

      pdf.text(footerText, pageWidth / 2, pageHeight - 5, {
        align: "center",
      });

      // ------------ 11. Watermark -----------------

      const watermarkText = "JewelCloud";
      pdf.setFontSize(90);
      pdf.setFont(undefined, "bolditalic");
      pdf.setTextColor(102, 102, 102);

      pdf.saveGraphicsState();
      pdf.setGState(pdf.GState({ opacity: 0.1 }));

      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;

      const textWidth = pdf.getTextWidth(watermarkText);
      const textHeight =
        pdf.internal.getFontSize() / pdf.internal.scaleFactor;

      const angleRad = (45 * Math.PI) / 180;
      const rotatedWidth =
        textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
      const rotatedHeight =
        textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

      const xPosWatermark = centerX - rotatedWidth / 2;
      const yPosWatermark = centerY + rotatedHeight / 4 + 40;

      pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });
      pdf.restoreGraphicsState();

      // ------------ 12. SAVE -----------------

      pdf.save("Jewelry-Category-Report.pdf");

    } catch (err) {
      console.error("Error generating Jewelry Category PDF:", err);
    }
  };



 const handleDownloadPricePieChart = async () => {
    try {
      // ------------ 1. High-Res Chart Setup -----------------
      const pdfChartOptions = {
        ...priceOptions,
        width: 1800,
        height: 950,
        chartArea: { left: 50, top: 140, width: "100%", height: "100%" },
        legend: { position: "none" },
        pieHole: 0.4,
        pieSliceText: "percentage",
        tooltip: { text: "percentage" },
        pieSliceTextStyle: { fontSize: 18, color: "#000" },
        colors: priceColorData, // Use same colors as legend
      };

      // ------------ 2. Hidden DOM Container -----------------
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-piechart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // ------------ 3. Custom Legends -----------------
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "flex-start";
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      priceChartData.slice(1).forEach((row, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "16px";
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = priceColorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const labelText = row[0].replace(/\s*\([^)]*\)\s*/g, "");
        const valueText = ` (${row[1]})`;

        const textNode = document.createTextNode(labelText + valueText);
        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // ------------ 4. Draw Chart -----------------
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "900px";
      hiddenContainer.appendChild(chartDiv);

      const tempChart = new window.google.visualization.PieChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(priceChartData);

      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // ------------ 5. Convert to Canvas -----------------
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");
      document.body.removeChild(hiddenContainer);

      // ------------ 6. Setup PDF -----------------
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;

      // ------------ 7. Header -----------------
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("JEWELRY PRICE REPORT", pageWidth - margin, 11, {
        align: "right",
      });

      // ------------ 8. Dynamic Info Block -----------------

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const normalizeIds = (arr) => arr.map((id) => Number(id));
      const vendorIds = normalizeIds(selectedData.vendorIds);
      const retailerIds = normalizeIds(selectedData.retailerIds);

      const selectedVendorNames =
        vendorIds.length === 0
          ? "All Vendors"
          : vendorList
            .filter((v) => vendorIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const selectedRetailerNames =
        retailerIds.length === 0
          ? "All Retailers"
          : retailerList
            .filter((v) => retailerIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(selectedData.fromDate).format(
        "MMM DD, YYYY"
      )} - ${moment(selectedData.toDate).format("MMM DD, YYYY")}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        ...(dealerMemberTypeName === "Admin"
          ? [
            `Vendors: ${selectedVendorNames}`,
            `Retailers: ${selectedRetailerNames}`
          ]
          : dealerMemberTypeName === "Vendor"
            ? [`Retailers: ${selectedRetailerNames}`]
            : [`Vendors: ${selectedVendorNames}`]
        ),
        `Total Clicks: ${totalCount}`
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // split text dynamically
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // ------------ 9. Insert Chart Below Dynamic Text -----------------

      const imgRatio = canvas.width / canvas.height;
      const availableHeight = pageHeight - currentY - footerHeight - 5;

      let imgWidthMM = pageWidth - margin * 2;
      let imgHeightMM = imgWidthMM / imgRatio;

      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        currentY,
        imgWidthMM,
        imgHeightMM,
        undefined,
        "FAST"
      );

      // ------------ 10. Footer -----------------

      pdf.setFillColor(31, 38, 62);
      pdf.rect(
        0,
        pageHeight - footerHeight,
        pageWidth,
        footerHeight,
        "F"
      );

      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);

      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;

      pdf.text(footerText, pageWidth / 2, pageHeight - 5, {
        align: "center",
      });

      // ------------ 11. Watermark -----------------

      const watermarkText = "JewelCloud";
      pdf.setFontSize(90);
      pdf.setFont(undefined, "bolditalic");
      pdf.setTextColor(102, 102, 102);

      pdf.saveGraphicsState();
      pdf.setGState(pdf.GState({ opacity: 0.1 }));

      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;

      const textWidth = pdf.getTextWidth(watermarkText);
      const textHeight =
        pdf.internal.getFontSize() / pdf.internal.scaleFactor;

      const angleRad = (45 * Math.PI) / 180;
      const rotatedWidth =
        textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
      const rotatedHeight =
        textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

      const xPosWatermark = centerX - rotatedWidth / 2;
      const yPosWatermark = centerY + rotatedHeight / 4 + 40;

      pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });
      pdf.restoreGraphicsState();

      // ------------ 12. SAVE -----------------

      pdf.save("Jewelry-Price-Report.pdf");

    } catch (err) {
      console.error("Error generating Jewelry Category PDF:", err);
    }
  };


  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 className="workarea__heading mt-0 mb-0">
                {t("Jewelry Chart Report")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>
          {dealerMemberTypeName === "Admin" ? (
            <>
              <div className="col-md-4">
                <div className="input__block">
                  <label> {t("Vendor(s)")} </label>
                  <Select
                    className="border__grey"
                    showSearch
                    mode="multiple"
                    showArrow
                    placeholder={t("Select one or more vendor")}
                    optionFilterProp="children"
                    value={selectedData.vendorIds}
                    onChange={(e) => handleOnChange(e, "select", "vendors")}
                  >
                    {vendorList.map((item, key) => {
                      return (
                        <Option key={item.dealerID} value={item.dealerID}>
                          {item.dealerCompany}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
              <div className="col-md-4">
                <div className="input__block">
                  <label> {t("Retailer(s)")} </label>
                  <Select
                    showSearch
                    showArrow
                    className="border__grey"
                    placeholder={t("Select one or more retailer ")}
                    optionFilterProp="children"
                    onChange={(e) => handleOnChange(e, "select", "retailers")}
                    notFoundContent={t("No Data Found")}
                    mode="multiple"
                    value={selectedData.retailerIds}
                  >
                    {retailerList.map((item, key) => {
                      return (
                        <Option key={key} value={item.dealerID}>
                          {item.dealerCompany}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </>
          ) : dealerMemberTypeName === "Vendor" ? (
            <div className="col-md-4">
              <div className="input__block">
                <label> {t("Retailer(s)")} </label>
                <Select
                  showSearch
                  showArrow
                  className="border__grey"
                  placeholder={t("Select one or more retailer ")}
                  optionFilterProp="children"
                  onChange={(e) => handleOnChange(e, "select", "retailers")}
                  notFoundContent={t("No Data Found")}
                  mode="multiple"
                  value={selectedData.retailerIds}
                >
                  {retailerList.map((item, key) => {
                    return (
                      <Option key={key} value={item.dealerID}>
                        {item.dealerCompany}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          ) : (
            <div className="col-md-4">
              <div className="input__block">
                <label> {t("Vendor(s)")} </label>
                <Select
                  className="border__grey"
                  showSearch
                  mode="multiple"
                  showArrow
                  placeholder={t("Select one or more vendor")}
                  optionFilterProp="children"
                  value={selectedData.vendorIds}
                  onChange={(e) => handleOnChange(e, "select", "vendors")}
                >
                  {vendorList.map((item, key) => {
                    return (
                      <Option key={item.dealerID} value={item.dealerID}>
                        {item.dealerCompany}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          )}

          <div className="col-md-4 mt-4">
            <div className="input__block">
              <button className="primary-btn mt-1" onClick={applyFilterHandler}>
                {t("Apply Filter")}
              </button>
            </div>
          </div>
          <Spin spinning={showLoader}>
            <div className="col-lg-12 col-md-6">
              <div className="input__block">
                <label>
                  <b>
                    {t("Total Jewelry Clicks")} : {totalCount}
                  </b>
                  <Tooltip
                    placement="right"
                    title={t(
                      "Displays the total number of jewelry clicks through the currently specified date range above"
                    )}
                  >
                    <img src={UnionIcon} alt="" />
                  </Tooltip>
                </label>
              </div>
            </div>
            <div className="col-lg-12">
              <label>
                <b> {t("Jewelry Clicks Based on Category")} </b>
              </label>
              <div
                className="chart__section"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "300px",
                }}
              >
                {categoryChartLoading ? (
                  <Spin size="large" />
                ) : categoryColumnData !== null &&
                  categoryColumnData.length >= 1 &&
                  countCategoryColumnData.length >= 1 &&
                  categoryTotalValuePercentage !== 0 &&
                  !showChartCategory ? (
                  <DoughnutChart
                    key={key}
                    label={categoryColumnData}
                    data={countCategoryColumnData}
                    typeGetter={tableSortHandler}
                    section={"category"}
                    totalValuePercentage={categoryTotalValuePercentage}
                    chartData={categoryChartData}
                    colorData={categoryColorData}
                    setChartData={setCategoryChartData}
                    setColorData={setCategoryColorData}
                    options={categoryOptions}
                  />
                ) : (
                  <div className="no-report-render">
                    <div className="desc-space">
                      <h6 className="linkText">
                        {t("Sorry, No Chart Data was found")}
                      </h6>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="button__block mb-4">
              <Button
                className="primary-btn mr-2"
                onClick={handleDownloadCategoryPieChart}
              >
                <i className="fa fa-download"></i> {t("Download Chart")}
              </Button>
            </div>

            <div className="col-lg-12">
              <label>
                <b> {t("Jewelry Clicks Based on Price")} </b>
              </label>
              <div
                className="chart__section"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "300px",
                }}
              >
                {priceChartLoading ? (
                  <Spin size="large" />
                ) : priceRange !== null &&
                  priceRange.length >= 1 &&
                  priceTotal.length >= 1 &&
                  priceTotalValuePercentage !== 0 &&
                  !showChartPrice ? (
                  <DoughnutChart
                    key={key}
                    label={priceRange}
                    data={priceTotal}
                    typeGetter={tableSortHandler}
                    section={"price"}
                    totalValuePercentage={priceTotalValuePercentage}
                    chartData={priceChartData}
                    colorData={priceColorData}
                    setChartData={setPriceChartData}
                    setColorData={setPriceColorData}
                    options={priceOptions}
                  />
                ) : (
                  <div className="no-report-render">
                    <div className="desc-space">
                      <h6 className="linkText">
                        {t("Sorry, No Chart Data was found")}
                      </h6>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Spin>

          <div className="col-lg-12 mt-3">
            <div className="options__div">
              <div className="row mb-4">
          <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
                  <Button
                  className="primary-btn mb-2 mb-lg-0 mr-2"
                    onClick={handleDownloadPricePieChart}
                  >
                    <i className="fa fa-download"></i> {t("Download Chart")}
                  </Button>
                  <Button
                    className="primary-btn"
                    onClick={() => handleExportToCSV()}
                    loading={downloadCSVDataloading}
                  >
                    <i className="fa fa-download"></i> {t("Download CSV")}
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                  scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              columns={columns}
              onChange={handleTableASCDES}
              pagination={{
                size: "small",
                total: totalCount,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
                pageSize: pageSize,
                current: pageNo,
              }}
              dataSource={tableChartData}
              loading={showTableLoader}
            />
          </div>
        </div>
      </div>
      <Modal
        title=""
        centered
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        width={500}
        footer={false}
        className="image-modal"
      >
        <div className="">
          <img src={selectedImage} className="img-fluid" />
        </div>
      </Modal>
      <Modal
        title=""
        centered
        visible={defaultVisible}
        onOk={() => setDefaultVisible(false)}
        onCancel={() => setDefaultVisible(false)}
        width={500}
        footer={false}
      >
        <div className="">
          <img src={DefaultImage} alt="img" className="img-fluid" />
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default GlobalJewelryChartReports;